export default __webpack_public_path__ + "static/media/loading_spinner.c8e6d403.gif";